module.exports = __webpack_public_path__ + "img/filters.c1b1a38e.svg";